export const GET_UUID_V5  = 'GET_UUID_V5';
export const GET_UUID_V4  = 'GET_UUID_V4';
export const GET_UUID_V3  = 'GET_UUID_V3';
export const GET_UUID_V1  = 'GET_UUID_V1';
export const GET_UUID_EMPTY  = 'GET_UUID_EMPTY';
export const GET_FILE  = 'GET_FILE';

